import { makeRequestAction } from './index';

export const getRoles = makeRequestAction('GET_ROLES', {
  onSuccess(params, response) {
    return {
      response: {
        ...response,
      },
    };
  },
});
